import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { SwiperOptions } from 'swiper';
import SwiperCore, { Zoom} from 'swiper';
SwiperCore.use([Zoom ]);

@Component({
  selector: 'app-lot-image',
  templateUrl: './lot-image.page.html',
  styleUrls: ['./lot-image.page.scss'],
})
export class LotImagePage implements OnInit {
  @Input() imageSource;
  config:SwiperOptions={
    zoom:{
      maxRatio:8
    },
  }
  constructor(
    public platformSRV:PlatformService,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
  }
  onCloseModal() {
   
    this.modalController.dismiss();
  }
}
